<template>
  <div>
    <!-- 7 类型 -->
    <div class="dragType" @dragover.prevent v-if="item && item.type === 7">
      <div class="type">
        <div
          class="boxType"
          @dragover.prevent
          @dragenter.prevent
          @dragleave="dragleave"
          @dragover="dragenter('renewable')"
        >
          <img class="img-top" src="@/assets/exam/23_left.png" alt="" />
          <img class="img-left" src="@/assets/exam/23.png" alt="" />
          <div class="left">
            <img
              v-for="(it, index) of renewableArr"
              :key="index"
              :src="require('@/assets/exam/drag/' + it + '.png')"
              alt=""
              @click="moveout(it)"
              @dragend="dragend($event, item.type, it)"
              draggable="true"
              @dragstart="dragstart($event, item.type, it)"
            />
          </div>
        </div>
        <div
          class="boxType"
          @dragover.prevent
          @dragenter.prevent
          @dragleave="dragleave"
          @dragover="dragenter('nonRenewable')"
        >
          <img class="img-top" src="@/assets/exam/23_right.png" alt="" />
          <img class="img-right" src="@/assets/exam/23.png" alt="" />
          <div class="right">
            <img
              v-for="(it, index) of nonRenewableArr"
              :key="index"
              :src="require('@/assets/exam/drag/' + it + '.png')"
              alt=""
              @click="moveout(it)"
              @dragend="dragend($event, item.type, it)"
              draggable="true"
              @dragstart="dragstart($event, item.type, it)"
            />
          </div>
        </div>
      </div>
      <div class="typeSmall">
        <div
          class="img"
          v-for="(it, index) of dragList"
          :key="index"
          @dragend="dragend($event, item.type, index)"
          draggable="true"
          @dragstart="dragstart($event, item.type, index)"
        >
          <img :src="require('@/assets/exam/drag/' + index + '.png')" alt="" />
          <div
            class="cover"
            :style="{
              opacity:
                (renewableArr.length > 0 && renewableArr.indexOf(index) > -1) ||
                (nonRenewableArr.length > 0 && nonRenewableArr.indexOf(index) > -1)
                  ? '0.5'
                  : ''
            }"
          ></div>
        </div>
      </div>
    </div>
    <!-- 9 类型 -->
    <div
      class="content remote-control"
      :class="getType ? '' : 'steer'"
      v-if="item && item.type === 9"
      @click="showOperation = false"
    >
      <div class="title" :style="item.style" @dragover.prevent @dragenter.prevent v-if="item.title">
        {{ item.title }}
      </div>
      <div class="controller" v-if="getType">
        <!-- <div class="list" v-for="item of 12" :key="item">
          <div></div>
        </div> -->
      </div>
      <img class="bicycle_img" v-else :src="require('@/assets/exam/48.png')" alt="" srcset="" />
      <div
        class="operation"
        ref="operation"
        @click.stop
        v-show="showOperation"
        :style="{ left: operationLeft + 'px', top: operationTop + 'px' }"
      >
        <div class="operationList" @click="showDetail(0)">
          <div>按键形状</div>
          <div>></div>
          <div class="detail">
            <div>
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f1b7223193/894614219.png"
                @click="configButton('shape', '0')"
                alt=""
              />
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f1b7a3ceca/525783613.png"
                @click="configButton('shape', '1')"
                alt=""
              />
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f1b7a74928/440097031.png"
                @click="configButton('shape', '2')"
                alt=""
              />
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f1b7a65b6e/624610234.png"
                @click="configButton('shape', '3')"
                alt=""
              />
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f7fbf8d13b/575261868.png"
                @click="configButton('shape', '4')"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="operationList" @click="showDetail(1)">
          <div>按键大小</div>
          <div>></div>
          <div class="detail">
            <div>
              <div @click="configButton('size', '0')">0.5倍</div>
              <div @click="configButton('size', '1')">正常</div>
              <div @click="configButton('size', '2')">1.5倍</div>
            </div>
          </div>
        </div>
        <div class="operationList" @click="showDetail(2)">
          <div>按键颜色</div>
          <div>></div>
          <div class="detail">
            <div>
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f1c8e8031e/210358970.png"
                @click="configButton('color', '0')"
                alt=""
              />
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f1c8e9336a/781579801.png"
                @click="configButton('color', '1')"
                alt=""
              />
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f1c8ea114e/251868879.png"
                @click="configButton('color', '2')"
                alt=""
              />
              <div
                style="background-color: #fdbf01; display: inlin-block; width: 22px; height: 22px"
                @click="configButton('color', '3')"
              ></div>
              <div
                style="background-color: #c45912; display: inlin-block; width: 22px; height: 22px"
                @click="configButton('color', '4')"
              ></div>
              <div
                style="background-color: #a5a5a5; display: inlin-block; width: 22px; height: 22px"
                @click="configButton('color', '5')"
              ></div>
            </div>
          </div>
        </div>
        <div class="operationList" @click="showDetail(3)">
          <div>文字大小</div>
          <div>></div>
          <div class="detail">
            <div>
              <div @click="configButton('fontSize', '0')">小</div>
              <div @click="configButton('fontSize', '1')">正常</div>
              <div @click="configButton('fontSize', '2')">大</div>
            </div>
          </div>
        </div>
        <div class="operationList" @click="showDetail(4)">
          <div>名字</div>
          <div>></div>
          <div class="detail">
            <div>
              <input
                type="text"
                v-model="title"
                placeholder="请输入名称"
                @input="changeTitle($event, item.type)"
                @click.stop
              />
            </div>
          </div>
        </div>
        <!-- <div class="operationList">
            <div>创意说明</div>
            <div> > </div>
            <div class="detail">
              <div style="height: 100px">
                <textarea
                  type="text"
                  v-model="explain"
                  placeholder="请输入创意说明"
                  @input="changeExplain"
                  @click.stop
                />
              </div>
            </div>
          </div> -->
      </div>
      <div class="button">
        <div class="box">
          <div
            class="list"
            v-for="(it, index) of item.customList"
            :key="index"
            :style="{ left: it.left + 'px', top: it.top + 'px' }"
            @dragend="dragend($event, item.type, index)"
            draggable="true"
            @dragstart="dragstart($event, item.type)"
            @contextmenu.prevent="contextmenu($event, index)"
          >
            <div
              class="shape"
              :style="{borderBottomColor: 'red'}"
              :class="['shape' + it.shape, 'size' + it.size, 'color' + it.color, 'fontSize' + it.fontSize]"
            >
              <div>{{ it.title }}</div>
            </div>
          </div>
        </div>
        <div v-if="getType" class="next" style="width: 160px" @click="add">增加按钮</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dragList: [],
      isEnter: false,
      pargentIndex: 0,
      index: 0,
      typeIndex: 0,
      typeSonIndex: 0,
      showOperation: false,
      operationLeft: 0,
      operationTop: 0,
      currentIndex: 0,
      explain: '',
      name: '',
      title: '',
      renewableArr: [],
      nonRenewableArr: [],
      type: '',
      start: false
    }
  },
  computed: {
    getType() {
      return !'examInnovationSteer, examCriticismSteer'.includes(this.$route.name)
    }
  },
  props: {
    list: {
      type: Object,
      default: () => {}
    },
    item: {
      type: Object,
      default: () => {}
    },
    submitList: {
      type: Array,
      default: () => []
    },
    isShowAnswer: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.initDrag()
  },
  methods: {
    showDetail(index) {
      this.hideDetailAll(index)
      const detail = this.$refs.operation.children[index].children[2]
      detail.style.display = detail.style.display === 'block' ? 'none' : 'block'
    },
    // 隐藏操作详情的所有二级。index为忽略项
    hideDetailAll(index) {
      this.$refs.operation.children.forEach((item, i) => {
        if (i !== index) {
          item.children[2].style.display = 'none'
        }
      })
    },
    initDrag() {
      this.dragList = []
      for (let index = 0; index < 7; index++) {
        this.dragList.push({
          left: 0,
          top: 0
        })
      }
    },
    dragstart(e, type, index) {
      if (type === 7) {
        this.index = index
      } else {
        this.startclientX = e.clientX // 记录拖拽元素初始位置
        this.startclientY = e.clientY
      }
      this.start = true
    },
    dragend(e, type, index) {
      if (type === 7) {
        if (!this.isShowAnswer) {
          this.$message({
            message: '看完视频后开始答题',
            type: 'warning'
          })
          return
        }
        if (!this.isEnter) return
        if (this.type === 'nonRenewable') {
          if (this.nonRenewableArr.indexOf(this.index) > -1) return
          // if (this.renewableArr.indexOf(this.index) > -1) return
          if (this.renewableArr.indexOf(this.index) > -1) {
            this.renewableArr.splice(this.renewableArr.indexOf(this.index), 1)
          }
          this.nonRenewableArr.push(this.index)
        } else if (this.type === 'renewable') {
          if (this.renewableArr.indexOf(this.index) > -1) return
          // if (this.nonRenewableArr.indexOf(this.index) > -1) return
          if (this.nonRenewableArr.indexOf(this.index) > -1) {
            this.nonRenewableArr.splice(this.nonRenewableArr.indexOf(this.index), 1)
          }
          this.renewableArr.push(this.index)
        }
        // this.dragList[index].left = Number(e.target.style.left.split('px')[0]) + e.clientX - this.startclientX + 'px'
        // this.dragList[index].top = Number(e.target.style.top.split('px')[0]) + e.clientY - this.startclientY + 'px'
      } else {
        if (this.item && this.item.type === 8) {
          if (!this.isEnter) return
          const current = this.item.typeList[this.typeIndex].children[this.typeSonIndex]
          //   this.currentQSmall.stemContent.forEach(it => {
          if (this.list.type === 'array') {
            if (current.index) {
              this.submitList[current.index].noCanMove = false
            }
            this.item.typeList[this.typeIndex].children[this.typeSonIndex] = {
              title: this.submitList[this.index].title,
              index: this.index,
              rotate: this.index * 100
            }
            this.submitList[this.index].noCanMove = true
          }
          //   })
        } else if (this.item && this.item.type === 9) {
          const minX = 'examController, examInnovationSteer'.includes(this.$route.name)
            ? window.innerWidth * 0.55
            : window.innerWidth * 0.5
          const isCrossed = e.clientX < minX
          if ('examController, examInnovationSteer'.includes(this.$route.name) && isCrossed) return
          this.item.customList[index].left = Number(e.target.style.left.split('px')[0]) + e.clientX - this.startclientX
          this.item.customList[index].top = Number(e.target.style.top.split('px')[0]) + e.clientY - this.startclientY
          console.log('e.target.style.left', e.target.style.left.split('px')[0], 'e.clientX', e.clientX, 'this.startclientX', this.startclientX)
        }
        // })
        this.$forceUpdate()
      }
    },
    dragenter(type) {
      this.isEnter = true
      this.type = type
      // this.typeIndex = index
      // this.typeSonIndex = indexSon
      // this.pargentIndex = e;
    },
    dragleave(el) {
      this.isEnter = false
    },
    moveout(index) {
      if (this.renewableArr.indexOf(index) > -1) {
        this.renewableArr.splice(this.renewableArr.indexOf(index), 1)
      } else if (this.nonRenewableArr.indexOf(index) > -1) {
        this.nonRenewableArr.splice(this.nonRenewableArr.indexOf(index), 1)
      }
    },
    changeTitle(e, type, index) {
      //   this.currentQSmall.askList.forEach(item => {
      if (this.item && this.item.type === 8 && this.item.typeList) {
        this.item.typeList[index].title = e.target.value
      } else if (this.item.type === 9 && this.item.customList) {
        this.item.customList[this.currentIndex].title = e.target.value
      }
      //   })
    },
    addAnswer(index) {
      //   this.currentQSmall.askList.forEach(item => {
      if (this.item && this.item.type === 8) {
        this.item.typeList[index].children.push({})
      }
      //   })
    },
    deleteAnswer(index, indexSon) {
      //   this.currentQSmall.askList.forEach(item => {
      if (this.item && this.item.type === 8) {
        this.item.typeList[index].children.splice(indexSon, 1)
      }
      //   })
    },
    contextmenu(e, index) {
      this.currentIndex = index
      this.showOperation = true
      this.operationLeft = e.clientX
      this.operationTop = e.clientY
      //   this.currentQSmall.askList.forEach(item => {
      if (this.item && this.item.type === 9) {
        this.title = this.item.customList[this.currentIndex].title
        this.explain = this.item.customList[this.currentIndex].explain
      }
      this.hideDetailAll(-1)
      //   })
    },
    configButton(type, value) {
      //   this.currentQSmall.askList.forEach(item => {
      if (this.item && this.item.type === 9) {
        this.item.customList[this.currentIndex][type] = value
      }
      this.showOperation = false
      //   })
    },
    changeExplain(e) {
      //   this.currentQSmall.askList.forEach(item => {
      if (this.item && this.item.type === 9) {
        this.item.customList[this.currentIndex].explain = e.target.value
      }
      //   })
    },
    add() {
      //   this.currentQSmall.askList.forEach(item => {
      if (this.item && this.item.type === 9) {
        this.item.customList.push({ left: 0, top: 0, title: '' })
      }
      //   })
    }
  }
}
</script>

<style lang="less" scoped>
.answerList {
  width: 200px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border: 2px solid #eee;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  cursor: move;
}
.bubble {
  display: flex;
  flex-wrap: wrap;
  .list {
    width: 200px;
    height: 200px;
    background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f0220cff66/403954923.png);
    background-size: 100% 100%;
    border-radius: 50%;
    margin: 200px;
    padding: 2px;
    position: relative;
    display: flex;
    align-items: center;
    justify-items: center;
    flex-wrap: wrap;
    input {
      background: none;
      outline: none;
      border: none;
      // margin: 0 auto;
      // margin-top: 80px;
      text-align: center;
      display: block;
      width: 200px;
      position: relative;
      z-index: 2;
      font-size: 20px;
    }
    .add {
      position: absolute;
      width: 26px;
      height: 26px;
      bottom: 29px;
      left: 87px;
      cursor: pointer;
      z-index: 2;
    }
    .listSon {
      position: absolute;
      left: 50%;
      margin-left: -33px;
      bottom: 100px;
      transform: rotate(45deg);
      transform-origin: 50% 100%;
      .line {
        width: 3px;
        height: 68px;
        background: #75e3ff;
        margin: 0 auto;
        margin-top: 9px;
        margin-bottom: 78px;
        border-radius: 2px;
      }
      .circle {
        width: 66px;
        height: 66px;
        background: linear-gradient(241deg, #67f7fc 0%, #348bff 100%);
        border-radius: 33px;
        // border: 1px solid;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        color: #333;
        font-size: 16px;
        transform: rotate(-45deg);
        // border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(230, 242, 252, 1)) 1 1;
      }
      .delete {
        width: 26px;
        height: 26px;
        display: block;
        position: relative;
        left: 60px;
        display: none;
        cursor: pointer;
      }
      &:hover .delete {
        display: block;
      }
    }
  }
}
.content {
  min-height: 553px;
  // background: #F5F5F5;
  border: 1px solid #efefef;
  margin-top: 28px;
  padding: 21px 33px;
  box-sizing: border-box;
  display: flex;
  position: relative;
  .bicycle_img {
    width: 100%;
  }
  .operation {
    width: 117px;
    // height: 176px;
    background: #ffffff;
    box-shadow: 0px 0px 10px -2px rgba(0, 0, 0, 0.15);
    position: fixed;
    top: 0;
    left: 0;
    padding: 0 10px;
    z-index: 10;
    .operationList {
      width: 100%;
      height: 36px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid rgba(109, 129, 156, 0.1);
      position: relative;
      cursor: pointer;
      div {
        font-size: 12px;
        font-weight: 400;
        color: #2b2d30;
        line-height: 14px;
      }
      .detail {
        position: absolute;
        left: 98%;
        top: 0;
        width: 140px;
        height: 36px;
        cursor: pointer;
        padding-left: 14px;
        display: none;
        > div {
          background: #ffffff;
          box-shadow: 0px 0px 10px -2px rgba(0, 0, 0, 0.15);
          border-radius: 4px;
          display: flex;
          height: 100%;
          justify-content: space-between;
          align-items: center;
          padding: 0 6px;
          > div {
            font-size: 12px;
            font-weight: 400;
            color: #2b2d30;
            line-height: 14px;
          }
          img {
            height: 20px;
          }
        }
      }
      input {
        width: 100%;
        &::-webkit-input-placeholder {
          font-size: 12px !important;
        }
      }
      textarea {
        background: none;
        outline: none;
        border: 1px solid #eee;
        margin: 10px 0;
        padding: 10px;
        height: 90%;
        box-sizing: border-box;
      }
    }
  }
  .controller {
    width: 380px;
    height: 781px;
    background: url(./../../../../assets/exam/49.png);
    background-size: 100% 100%;
    background-position: center;
    // box-shadow: 0px 0px 8px 0px #CDD9E5;
    border-radius: 33px;
    display: flex;
    flex-wrap: wrap;
    padding: 27px 17px 23px 17px;
    position: relative;
    .list {
      width: 115px;
      height: 185px;
      padding: 10px 5px;
      // border-top: 4px double #ccc;
      // border-right: 3px dashed #ccc;
      // background: linear-gradient(151deg, #DCE6EF 0%, #F1F6FA 100%);
      // border-radius: 16px;
      // border: 1px solid rgba(57, 149, 255, 1);
      > div {
        width: 102px;
        height: 165px;
        // background: linear-gradient(151deg, #DCE6EF 0%, #F1F6FA 100%);
        // border-radius: 16px;
        // border: 1px solid rgba(57, 149, 255, 1);
      }
      // margin-right: 20px;
    }
    .list:nth-child(1),
    .list:nth-child(2),
    .list:nth-child(3) {
      border-top: 0;
    }
    .list:nth-child(3n) {
      margin-right: 0;
      border-right: 0;
    }
    .customList {
      width: 102px;
      height: 165px;
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f1c8e8031e/210358970.png);
      background-size: 100% 100%;
      border-radius: 6px;
      cursor: move;
      > div {
        width: 20px;
        word-wrap: break-word;
        font-size: 16px;
        color: #fff;
      }
    }
    // .shape
  }
  .button {
    width: 310px;
    margin-left: 66px;
    padding-top: 10px;
    // flex: 1;
    .box {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      .list {
        margin-right: 13px;
        width: 102px;
        height: 165px;
        // background: linear-gradient(241deg, #67F7FC 0%, #348BFF 100%);
        border-radius: 16px;
        // border: 1px solid;
        // border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(230, 242, 252, 1)) 1 1;
        margin-bottom: 18px;
        cursor: move;
        position: relative;
        left: 0;
        top: 0;
        > div {
          width: 100%;
          height: 100%;
          background: linear-gradient(241deg, #67f7fc 0%, #348bff 100%);
          border-radius: 16px;
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          > div {
            width: 20px;
            word-wrap: break-word;
            font-size: 16px;
            color: #fff;
          }
        }
        .size0 {
          transform: scale(0.5);
          > div {
            transform: scale(2);
          }
        }
        .size1 {
          transform: scale(1);
          > div {
            transform: scale(1);
          }
        }
        .size2 {
          transform: scale(1.5);
          > div {
            transform: scale(0.66);
          }
        }
        .color0 {
          background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f1c8e8031e/210358970.png);
        }
        .color1 {
          background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f1c8e9336a/781579801.png);
        }
        .color2 {
          background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f1c8ea114e/251868879.png);
        }
        .color3 {
          background-image: none;
          background-color: #fdbf01;
        }
        .color4 {
          background-image: none;
          background-color: #c45912;
        }
        .color5 {
          background-image: none;
          background-color: #a5a5a5;
        }
        .shape.shape0 {
          width: 102px;
          height: 165px;
        }
        .shape.shape1 {
          width: 165px;
          height: 102px;
          div {
            width: 100%;
            text-align: center;
          }
        }
        .shape2 {
          width: 102px;
          height: 102px;
        }
        .shape3 {
          width: 102px;
          height: 102px;
          border-radius: 50%;
        }
        .shape4 {
          width: 102px;
          height: 102px;
          background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f7eba7456c/826832706.png);
          border-radius: 0;

          // width: 0;
          // height: 0;
          // border-left: 90px solid transparent;
          // border-right: 90px solid transparent;
          // border-bottom: 100px solid #000; /* 可以修改颜色 */
        }
        .shape4.color2 {
          background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f7eba8b312/334378846.png);
        }
        .shape4.color1 {
          background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f7eba961dc/762183950.png);
        }
        .shape4.color3 {
          background-color: transparent;
          background-image: url('~@/assets/exam/theme0/yellow-triangle.png');
        }
        .shape4.color4 {
          background-color: transparent;
          background-image: url('~@/assets/exam/theme0/brown-triangle.png');
        }
        .shape4.color5 {
          background-color: transparent;
          background-image: url('~@/assets/exam/theme0/gray-triangle.png');
        }
        .fontSize0 {
          > div {
            font-size: 14px;
          }
        }
        .fontSize1 {
          > div {
            font-size: 18px;
          }
        }
        .fontSize2 {
          > div {
            font-size: 22px;
          }
        }
      }
    }
    .next {
      width: 269px;
      height: 44px;
      background: #f8f9ff;
      border-radius: 22px;
      display: flex;
      background: var(--button-bg-color);
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 400;
      color: #fff;
      line-height: 20px;
      margin: 0 auto;
      // margin-top: 37px;
      cursor: pointer;
      // position: absolute;
      // bottom: 15px;
      // right: 90px;
    }
  }
}
.content.steer {
  flex-wrap: wrap;
  justify-content: flex-end;
  flex-direction: column-reverse;
  .button {
    width: 100%;
    flex: none;
    margin-left: 0;
    padding-bottom: 0;
    justify-content: center;
    .list {
      width: 65px;
      height: 105px;
    }
    .shape.shape0 {
      width: 65px;
      height: 105px;
    }
    .shape.shape1 {
      width: 105px;
      height: 65px;
      div {
        width: 100%;
        text-align: center;
      }
    }
    .shape2 {
      width: 65px;
      height: 65px;
    }
    .shape3 {
      width: 65px;
      height: 65px;
      border-radius: 50%;
    }
    .shape4 {
      width: 65px;
      height: 65px;
      background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f7eba7456c/826832706.png);
      border-radius: 0;
    }
  }
}
.dragType {
  width: 100%;
  min-height: 550px;
  border: 1px solid #eee;
  background: #f5f5f5;
  border-radius: 6px;
  margin-top: 20px;
  .type {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    .boxType {
      width: 48%;
      min-height: 280px;
      position: relative;
      .img-top {
        height: 37px;
        position: absolute;
        z-index: 2;
        top: -8px;
        margin-left: calc((100% - 186px) / 2);
      }
      .img-left,
      .img-right {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1;
      }
      .left,
      .right {
        width: 100%;
        min-height: 280px;
        z-index: 2;
        padding: 20px;
        padding-top: 35px;
        img {
          width: 32%;
          // height: 105px;
          margin-top: 10px;
          margin-right: 2%;
          z-index: 3;
          position: relative;
          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
  }
  .typeSmall {
    position: relative;
    width: 96%;
    margin: 0 auto;
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    .img,
    > img {
      height: 105px;
      position: relative;
      top: 0;
      cursor: move;
      margin-right: 10px;
    }
    .cover {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      background: #e1e1e1;
    }
  }
}
</style>
